import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';

import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class GfTranslateService {

    constructor(
        private translateService: TranslateService,
        private http: HttpClient        
    ) { }

    /**
     * Switches to the given language
     * 
     * @param lang languago to switch to
     */
    setLanguage(lang: string = ''): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.translateService.currentLang != lang) {
                const translationPath = `/core/js/i18n/${lang}.json`;
                this.http.get<any>(translationPath).subscribe(
                    translations => {
                      this.translateService.setTranslation(lang, translations);
                      this.translateService.use(lang).subscribe(
                          () => resolve(null),
                          () => resolve(null)
                      );
                    },
                    error => {
                      console.error(`Failed to load translations for ${lang}:`, error);
                      resolve(null);
                    }
                );
            } else {
                resolve(null);
            }
        });
    }

    /**
     * Escapes characters so that the given string can be safely used in a regular expression
     * 
     * @param string 
     * @returns string
     */
    escapeRegExp(string) {
        return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // Escaping special characters
    }

    /**
     * Replaces all occurrences of a substring with another string
     * 
     * @param string string to process
     * @param find substring to find
     * @param replace string to replace substring with
     * @returns string
     */
    replaceAll(string, find, replace) {
        return string.replace(new RegExp(this.escapeRegExp(find), 'g'), replace);
    }

    /**
     * Given a string (key) and an optional list of parameters in a {key: value} format,
     * returns the translated string, accor
     * @param key 
     * @param params 
     * @returns string
     */
    translate(key: string, params?: any) {
        let value: string = this.translateService.instant(key);

        if (params) {
            _.forEach(params, (pvalue, pkey) => {
                value = this.replaceAll(value, '{{' + pkey + '}}', pvalue);
            })
        }

        return value;
    }

    setStrings(key: string, translations: any) {
        this.translateService.setTranslation(key, translations, true);  // true - merge with existing
    }
}
